import { adminAuthenticationImpersonateStopGetSlice } from './get';

export const {
	requestGetAdminAuthenticationImpersonateStop,
	resetGetAdminAuthenticationImpersonateStop
} = adminAuthenticationImpersonateStopGetSlice.asyncActionCreators;
